import { createContext, useContext, useMemo, useState } from "react";

import Service from "../api/service";
import { useAdminContext } from "./admin/AdminContext";

const PaymentContext = createContext(null);

export const usePaymentContext = () => {
  const v = useContext(PaymentContext);
  if (!v) {
    throw new Error("usePaymentContext must be used inside PaymentProvider");
  }
  return v;
};

export const PaymentProvider = ({ children }) => {
  const [payment, setPayment] = useState(null);
  const [count, setCount] = useState(0);
  const { sysAdmin } = useAdminContext();

  const updatePaymentState = async (next) => setPayment(next);

  const hasCompany =
    sysAdmin?.company_id !== null && sysAdmin?.company_id !== undefined;

  const fetchPayments = async (page = 1, pageSize = 50) => {
    // Without a company scope the backend returns 404 for `/company/null/`.
    // Short-circuit so the UI can render an informative empty state instead.
    if (!hasCompany) {
      setPayment([]);
      setCount(0);
      return { status: 200, data: { rows: [], count: 0 } };
    }
    const url = `/api/v1/payment/company/${sysAdmin.company_id}/?page=${page}&pageSize=${pageSize}`;
    const response = await Service.get(url);
    const payload = response?.data;
    if (payload) {
      setPayment(payload.rows);
      setCount(payload.count);
    }
    return response;
  };

  const value = useMemo(
    () => ({ payment, count, hasCompany, fetchPayments, updatePaymentState }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [payment, count, sysAdmin?.company_id],
  );

  return (
    <PaymentContext.Provider value={value}>{children}</PaymentContext.Provider>
  );
};
